// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dMZPkX9_fJU0Ok0NIiZ6{--background-neutral-default:var(--background-primary-inverted-primary);background:var(--black-10);border-radius:10px;padding:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabs": `dMZPkX9_fJU0Ok0NIiZ6`
};
export default ___CSS_LOADER_EXPORT___;
